import React, { useState, useEffect, useCallback } from "react";
import Timer from "./Timer";
import moment from 'moment';
import { CircularProgress } from '@material-ui/core';

function TimeCounter(props) {
    const getInitialSeconds = useCallback(() => {
        const limitDateString = props.transaction.manual_analysis_limit_date;
        if (!limitDateString) {
            return null;
        }
        const limit = moment.utc(limitDateString); 
        const now = moment.utc();

        return limit.diff(now, 'seconds');
    }, [props.transaction.manual_analysis_limit_date]);

    const [totalSeconds, setTotalSeconds] = useState(getInitialSeconds);
    useEffect(() => {
        setTotalSeconds(getInitialSeconds());
    }, [getInitialSeconds]);

    useEffect(() => {
        if (totalSeconds > 0) {
            const timerId = setTimeout(() => {
                setTotalSeconds(prevTotalSeconds => prevTotalSeconds - 1);
            }, 1000);

            return () => clearTimeout(timerId);
        }
    }, [totalSeconds]);

    if (totalSeconds > 0) {
        const remaining_minutes = Math.floor(totalSeconds / 60);
        const remaining_seconds = totalSeconds % 60;
        return (
            <div className="analysisCard" style={{ height: "100%" }}>
                <div style={{ margin: "auto", display: "flex" }}>
                    <Timer
                        ra_limit={props.transaction.manual_analysis_limit_date}
                        time={{ minutes: remaining_minutes, seconds: remaining_seconds }}
                    />
                </div>
            </div>
        );
    }
    else if (totalSeconds !== null) {
        return (
            <div className="analysisCard" style={{ height: "100%" }}>
                <div
                    className="normalText subtitleSize bold"
                    style={{ margin: "auto", color: "blue" }}
                >
                    Tempo para decisão manual expirado!
                </div>
            </div>
        );
    }
    else {
        return (
            <div className="analysisCard" style={{ height: "100%" }}>
                <div style={{ margin: "auto" }}>
                    <CircularProgress />
                </div>
            </div>
        );
    }
}

export default TimeCounter;